import { cr, URLS, interact } from "fire-wind-water";
import authService from "@/services/authService";
import { common } from "@/model/common";
import WX from "@/model/wx";
import md5 from "js-md5";
import { loginData } from "@/model/loginData";
import mixinConfig from "@/mixin/config";
import Header from "@/components/Header";
import Banner from "@/components/Banner";
import LangManager from "@/model/lang";

export default {
  name: "login",
  components: {
    Header,
    Banner,
  },
  data() {
    return {
      isLoad: false,
      isPassWordLogin: false,
      isSavePassWord: false,
      isCodeLoad: false,
      passwordErrorMsg: "",
      captchaErrorMsg: "",
      count: 60,
      timer: null,
      // phone: "", // string 唯一标识。可能是用户名，邮箱，手机等;记录住密码的传 cookie
      password: "",
      captcha: "", // string 动态验证码。手机或邮箱动态验证登录传此项
      url: window.location.href,
      weChatId: common.weChatId,
      memberFormId: common.memberFormId, //  表单ID
      memberSchemaId: common.memberSchemaId,
      schemaId: common.schemaId, // 体系ID
      tenantId: common.tenantId, // 租户Id
      isSubmitting: false, //是否可以登录
      needBindAfterOAuth: false, // 第三方登录后是否绑定
      defaultIdentityType: "", //  默认登录方式
      supportNormal: true, //是否支持普通登录
      supportCustom: true, // 是否支持自定义标识登录
      supportOAuth: true, // 是否支持第三方登录
      supportCaptcha: true, // 是否支持验证码登录
      normalIdentityFields: [], // 登录信息
      customIdentityFields: [], // 用户自定义标识列表
      hasOtherIdentityType: true, // 是否含有其他登录方式
      qq: {
        isSupport: false,
        loginUrl: "",
        callbackUrl: "",
      },
      weChat: {
        isSupport: false,
        loginUrl: "",
        callbackUrl: "",
      },
      weChatWeb: {
        isSupport: false,
        loginUrl: "",
        callbackUrl: "",
      },
      identity: "", // 身份标识
      customPlaceholder: "", // 身份标识占位符
      normalIdentityPlaceholder: "", // 普通登录占位符
      isEnableSignup: false, // 是否启用注册
      phoneField: null, // 手机号字段
      token: common.token, // 第三方登录后的token
      verify: "", // 获取到的微信实例的粉丝token
      returnUrl: encodeURIComponent(
        window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname.replace("index", "short")
      ), // 第三方登录后的跳转地址
      pcReturnUrl: window.location.href,
      openId: "", // 社交用户openID
      name: "", // 社交用户name
      nickname: "", // 社交用户nickName
      avatar: "", // 社交用户avatar
      email: "", // 社交用户email
      backUrl: common.backUrl,
      inWeChat: interact.isWeChat,
      userInfo: "",
      settingBackUrl: "",
      accountFieldValue: "", // 账号字段值
      phoneFieldValue: "", // 手机号字段值
      accountField: [], // 账号字段
      customField: null,
      phoneErrorMsg: "", //手机号错误提示
      accountErrorMsg: "", // 账号错误提示
      passwordSignInErrorMsg: "", // 密码登录错误提示
      captchaSignInErrorMsg: "", // 验证码登录错误提示
      isShowOtherModel: false,
      loginType: "",
      isNormal: true,
      isShowThird: true,
      isShowPhoneTips: false,
      phone: "1",
      country: "us",
      onlyCountry: [],
    };
  },
  mixins: [mixinConfig],
  methods: {
    changePhone(data) {
      if (data) {
        this.phone = data.dialCode;
        this.country = data.iso2;
      }
    },

    loginInit() {
      let self = this;
      self.userInfo = common.getSession();
      if (!self.backUrl) {
        let backUrlSetting = self.extras.backlink.href;
        self.settingBackUrl = RegExp("^https?:\\/\\/.+").test(backUrlSetting)
          ? backUrlSetting
          : "";
      } else {
        try {
          // common.backUrl = encodeURIComponent(window.atob(decodeURIComponent(common.backUrl)));
          let url = common.backUrl;
          url = decodeURIComponent(url);
          url = window.atob(url);
          self.backUrl = url;
          common.backUrl = url;
        } catch (error) {
          self.backUrl = common.backUrl;
        }
      }
      if (self.userInfo && self.userInfo.session) {
        if (self.backUrl || self.settingBackUrl) {
          if (self.backUrl) {
            return common.handBackUrl(common.backUrl);
          } else {
            return window.$sk.goto(self.settingBackUrl);
          }
        } else {
          return common.routerPush(this, "loginSuccess");
        }
      }
      authService
        .getForNewForm({
          tenantId: common.tenantId,
          memberFormId: self.memberFormId,
          schemaId: self.schemaId,
        })
        .then((res) => {
          if (res.result != 0) return;
          let formInfo = res.content;
          common.handPage(formInfo);
          window.$sk.template.update({
            type: "link",
            data: {
              identity: 1,
              weChatId: formInfo.authWeChatId || 0,
              skObjectType: "member",
              skObjectId: self.memberFormId,
              meetingInstanceId: "",
              meetingType: "",
              skIsNotLink: "",
              memberFormId: "",
            },
          });
          if (formInfo.authWeChatId) {
            self.weChatId = formInfo.authWeChatId;
            WX.initWeChatShare(formInfo);
          }
          self.isEnableSignup =
            formInfo.isEnableSignup != undefined
              ? parseInt(formInfo.isEnableSignup)
              : true;
        });
    },
    load() {
      authService
        .getUnique({
          memberFormId: this.memberFormId,
          schemaId: this.schemaId,
        })
        .then(
          (res) => {
            if (res.content["fields"].length == 0)
              common.routerPush(this, "null");
            this.protoInit(res.content);
            window.$sk.loading.hide();
            this.isLoad = true;
          },
          (data) => {
            window.$sk.tips.show(data.desc);
            window.$sk.loading.hide();
            this.isLoad = true;
          }
        );
    },
    protoInit(uniqueInfo) {
      const self = this;
      self.schemaId = uniqueInfo["memberSchemaId"];
      self.tenantId = uniqueInfo["tenantId"];
      self.needBindAfterOAuth = uniqueInfo["thirdBind"] === "1";
      self.defaultIdentityType = uniqueInfo["default"];
      self.isPassWordLogin = self.defaultIdentityType != "checkcode";
      if (cr.isArray(uniqueInfo["type"])) {
        self.supportNormal = uniqueInfo["type"].indexOf("normal") > -1;
        self.supportCustom = uniqueInfo["type"].indexOf("custom") > -1;
        self.supportOAuth = uniqueInfo["type"].indexOf("third") > -1;
        self.supportCaptcha = uniqueInfo["type"].indexOf("checkcode") > -1;
      }
      cr.each(uniqueInfo["fields"], (item) => {
        // i18n：根据当前语言覆盖 displayName
        const lang =
          (typeof LangManager !== "undefined" && LangManager.current) ||
          "zh_CN";
        if (
          lang !== "zh_CN" &&
          item.i18n &&
          (item.i18n[lang] || item.i18n[lang.toLowerCase()])
        ) {
          item.displayName = item.i18n[lang] || item.i18n[lang.toLowerCase()];
        }
        item["isSystemed"] + "" == "1"
          ? self.normalIdentityFields.push(item)
          : self.customIdentityFields.push(item);
        if (!item.textRegularExpression) {
          item.textRegularExpression = item.regularExpression;
        }
        if (self.supportCaptcha && item["fieldName"] === "mobile") {
          self.phoneField = item;
          if (self.phoneField.isCallingCodeOpen == 1) {
            self.isShowPhoneTips = true;
          }
          if (self.phoneField.showCallingCode) {
            this.onlyCountry = self.phoneField.showCallingCode.map((r) => {
              if (r.callingCode == self.phoneField.defaultCallingCode) {
                this.country = r.callingCode;
                this.phone = r.areaCode;
              }
              return r.callingCode;
            });
          }
          self.phoneField.isSendSms = "0";
          self.phoneField.required = parseInt(self.phoneField.required);
        }
        self.accountField.push(item);
      });
      if (
        self.defaultIdentityType == "custom" ||
        (self.defaultIdentityType == "third" &&
          !self.supportNormal &&
          self.supportCustom &&
          self.customIdentityFields.length > 0)
      ) {
        this.isNormal = false;
        self.customField = self.customIdentityFields[0];
        self.customPlaceholder = self.customIdentityFields[0].displayName;
      }
      self.normalIdentityPlaceholder = self.normalIdentityFields
        .map((item) => {
          if (item["isSystemed"] + "" == "1") return item["displayName"];
        })
        .join("/");

      if (self.normalIdentityFields.length > 1) {
        self.loginType = self.normalIdentityFields
          .map((item) => {
            return item["fieldName"];
          })
          .join("/");
      } else if (self.customIdentityFields.length > 0) {
        self.customPlaceholder = self.customIdentityFields[0].displayName;
        self.loginType = self.customIdentityFields[0]["fieldName"];
      }
      if (uniqueInfo["type"].length > 1 || self.customIdentityFields.length > 1)
        self.hasOtherIdentityType = true;
      if (uniqueInfo["fields"].length <= 0) common.routerPush(self, "null");
      //支持哪些第三方登录方式
      if (uniqueInfo["oauthInfo"]) {
        if (
          Object.prototype.hasOwnProperty.call(uniqueInfo["oauthInfo"], "qq")
        ) {
          self.oAuthInfo = uniqueInfo["oauthInfo"]["qq"];
          self.qq.isSupport = true;
          self.qq.loginUrl = self.oAuthInfo["loginUrl"];
          self.qq.callbackUrl =
            self.oAuthInfo["callbackUrl"] + "?return_url=" + self.returnUrl;
        }
        if (
          Object.prototype.hasOwnProperty.call(
            uniqueInfo["oauthInfo"],
            "wechat"
          )
        ) {
          self.oAuthInfo = uniqueInfo["oauthInfo"]["wechat"];
          self.weChat.isSupport = true;
          self.weChat.loginUrl = URLS.updateParam(
            "return_url",
            self.returnUrl,
            self.oAuthInfo["loginUrl"]
          );
          self.weChat.callbackUrl = URLS.updateParam(
            "return_url",
            self.returnUrl,
            self.oAuthInfo["callbackUrl"]
          );
        }
        if (
          Object.prototype.hasOwnProperty.call(
            uniqueInfo["oauthInfo"],
            "wechat_web"
          )
        ) {
          self.oAuthInfo = uniqueInfo["oauthInfo"]["wechat_web"];
          self.weChatWeb.isSupport = true;
          self.weChatWeb.loginUrl = self.oAuthInfo["loginUrl"];
          self.weChatWeb.callbackUrl =
            self.oAuthInfo["callbackUrl"] + "?return_url=" + self.returnUrl;
        }
      }
    },
    getCode() {
      this.phoneErrorMsg = this.phoneFieldValue
        ? this.phoneErrorMsg
        : this.$t("field.required", { name: this.$t("field.phone") });
      if (!this.phoneErrorMsg) {
        this.sendCheckCode();
      }
      // this.sendCheckCode();
    },
    routerRegister() {
      common.routerPush(this, "register");
    },
    routerRetrievePassword() {
      common.routerPush(this, "retrievePassword");
    },
    sendCheckCode() {
      const param = {
        unique:
          this.phoneField.isCallingCodeOpen == 1
            ? this.phone + this.phoneFieldValue
            : this.phoneFieldValue,
        memberSchemaId: this.schemaId,
        validTime: 600, //验证码的有效期。如果没传默认是600秒（10分钟）
        intervalTime: 60, //重发的间隔时间。如果没传默认是60秒（1分钟）。可用于界面倒计时
        action: "login", //应用场景，用途。默认值是all。login:登录，register:注册，resetpassword:重置或修改密码，all:所有场景下通用。目前只有这四种。以后不同场景用途发送的内容由后台短信或邮件模板定义（现在未实现，还是由后台代码实现的）
        browseInfo: interact.browseInfo,
      };
      authService.sendCheckCode(param).then(
        () => {
          if (!this.timer) {
            this.isCodeLoad = true;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= 60) {
                this.count--;
              } else {
                this.isCodeLoad = false;
                this.count = 60;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        },
        (data) => {
          window.$sk.tips.show(data["desc"]);
        }
      );
    },
    passWordChange() {
      this.passwordSignInErrorMsg = "";
      if (!this.password)
        return (this.passwordErrorMsg = this.$t("common.pleaseInputPassword"));
      return (this.passwordErrorMsg =
        this.password.length < 6 || this.password.length > 20
          ? " " + this.$t("login.passwordLengthError") + " "
          : "");
    },
    captchaChange() {
      this.captchaSignInErrorMsg = "";
      return (this.captchaErrorMsg = this.captcha
        ? ""
        : this.$t("field.please_input_captcha"));
    },
    accountFieldBlur() {
      if (!this.accountFieldValue)
        return (this.accountErrorMsg = this.$t("field.please_input", {
          name: this.isNormal
            ? this.normalIdentityPlaceholder
            : this.customPlaceholder,
        }));
      let isError = true;
      if (this.isNormal) {
        this.accountField.filter((item) => {
          if (
            item.textRegularExpression &&
            new RegExp(item.textRegularExpression).test(this.accountFieldValue)
          ) {
            isError = false;
            return;
          }
        });
      } else {
        if (!this.customField.textRegularExpression) return;
        isError = !(
          this.customField.textRegularExpression &&
          new RegExp(this.customField.textRegularExpression).test(
            this.accountFieldValue
          )
        );
      }
      return (this.accountErrorMsg = isError
        ? this.$t("field.pattern", {
            name: this.isNormal
              ? this.normalIdentityPlaceholder
              : this.customPlaceholder,
          })
        : "");
    },
    phoneFieldBlur() {
      if (!this.phoneFieldValue) {
        return (this.phoneErrorMsg = this.$t("field.please_input", {
          name: this.phoneField.displayName,
        }));
      }
      if (!this.phoneField.textRegularExpression) return;
      if (
        this.phoneField.textRegularExpression &&
        new RegExp(this.phoneField.textRegularExpression).test(
          this.phoneFieldValue
        )
      ) {
        this.phoneErrorMsg = "";
      } else {
        this.phoneErrorMsg = this.$t("field.pattern", {
          name: this.phoneField.displayName,
        });
      }
    },
    phoneFieldChange() {
      this.captchaSignInErrorMsg = "";
    },
    accountFieldChange() {
      this.passwordSignInErrorMsg = "";
    },
    keySubmit(e) {
      if (e.keyCode == 13) {
        this.submit();
      }
    },
    submit() {
      let self = this;
      if (self.isPassWordLogin) {
        if (self.passwordSignInErrorMsg) return;
        self.accountErrorMsg = self.accountFieldValue
          ? self.accountErrorMsg
          : self.$t("field.please_input", {
              name: self.isNormal
                ? self.normalIdentityPlaceholder
                : self.customPlaceholder,
            });
        self.passwordErrorMsg = self.password
          ? self.passwordErrorMsg
          : self.$t("common.pleaseInputPassword");
        if (!self.accountErrorMsg && !self.passwordErrorMsg) {
          self.idSignIn();
        }
      } else {
        // self.$set(this.phoneField, "checkFlag", !this.phoneField.checkFlag);
        // self.$nextTick(() => {
        // });
        // if (
        //   !this.phoneField.value.value ||
        //   this.phoneField.value.VerifyFail
        // ) {
        //   return;
        // }
        // // console.log(window.$s_temp);
        if (self.captchaSignInErrorMsg) return;
        self.phoneErrorMsg = self.phoneFieldValue
          ? self.phoneErrorMsg
          : this.$t("field.required", { name: this.$t("field.phone") });
        self.captchaErrorMsg = self.captcha
          ? self.captchaErrorMsg
          : self.$t("field.please_input_captcha");
        if (!self.phoneErrorMsg && !self.captchaErrorMsg) {
          this.caSignIn();
        }
      }
    },
    idSignIn() {
      let self = this;
      self.isSubmitting = true;
      self.loginType = self.loginType.indexOf("/") > -1 ? "" : self.loginType;
      let requestData = {
        tenantId: self.tenantId, //int 租户Id
        schemaId: self.schemaId, //int 体系Id（选填）
        memberFormId: self.memberFormId, //表单id
        memberSchemaId: self.schemaId,
        unique: "", //string 唯一标识。可能是用户名，邮箱，手机等;记录住密码的传 cookie
        verify: self.verify,
        token: self.token, //string 第三方登录传 token，token时不需要密码或是动态验证码 ;
        password: "", //string 密码。账号密码的形式必传此项。
        checkCode: "", //string 动态验证码。手机或邮箱动态验证登录传此项
        loginType: self.isNormal ? "" : self.loginType, //string 登录方式（选填。主要是用于标识用户名，邮箱，手机等.其他标识方式必填）
        url: window.location.href,
        browseInfo: interact.browseInfo, //broseInfo
      };
      requestData["unique"] = self.accountFieldValue;
      // requestData["password"] = self.password;
      requestData["password"] = md5(self.password).toUpperCase();
      if (self.inWeChat && (self.weChatId || self.backUrl)) {
        if (!this.weChatId) {
          let url = decodeURIComponent(common.backUrl);
          let re = new RegExp("(^|&)" + "weChatId" + "=([^&]*)(&|$)", "i");
          let Parameter = url.match(re);
          if (Parameter !== null) {
            this.weChatId = Parameter[2];
          }
        }
        if (requestData.verify) {
          requestData.verify = common.getVerify(this.weChatId);
        }
      }
      authService.login(requestData).then(
        (data) => {
          if (data.result != 0) {
            self.isSubmitting = false;
            return (self.passwordSignInErrorMsg = data.desc);
          }
          common.setSession(
            {
              session: data.content.sess,
              memberId: data.content.memberId,
            },
            7
          );
          //判断状态
          // if (this.isSavePassWord) {
          //   //保存密码
          //   common.setSession(
          //     {
          //       session: data.content.sess,
          //       memberId: data.content.memberId
          //     },
          //     7
          //   );
          // } else {}
          self.signInSuccessHandler(data);
        },
        (data) => {
          self.signInFailHandler(data);
        }
      );
    },
    caSignIn() {
      let self = this;
      self.isSubmitting = true;
      let requestData = {
        tenantId: self.tenantId, //int 租户Id
        schemaId: self.schemaId, //int 体系Id（选填）
        memberFormId: self.memberFormId, //表单id
        unique:
          this.phoneField.isCallingCodeOpen == 1
            ? this.phone + self.phoneFieldValue
            : self.phoneFieldValue, //string 唯一标识。可能是用户名，邮箱，手机等;记录住密码的传 cookie
        token: "", //string 第三方登录传 token，token时不需要密码或是动态验证码 ;
        verify: self.verify,
        password: "", //string 密码。账号密码的形式必传此项。
        checkCode: self.captcha, //string 动态验证码。手机或邮箱动态验证登录传此项
        loginType: "mobile", //string 登录方式（选填。主要是用于标识用户名，邮箱，手机等.其他标识方式必填）
        url: window.location.href,
        browseInfo: interact.browseInfo,
      };
      if (this.phoneField.isCallingCodeOpen == 1) {
        requestData[this.phoneField.codeFieldName] = this.country;
      }
      // requestData.loginType = "mobile";
      return authService
        .getToken({
          unique:
            this.phoneField.isCallingCodeOpen == 1
              ? this.phone + self.phoneFieldValue
              : self.phoneFieldValue,
          checkCode: self.captcha,
          schemaId: self.schemaId,
          formId: self.memberFormId,
          action: "login",
          sourceKey: common.sourceKey,
        })
        .then(
          (data) => {
            if (data.result != 0) {
              self.isSubmitting = false;
              return (self.captchaSignInErrorMsg = data["desc"]);
            }
            requestData["token"] = data["content"]["token"];
            common.setToken(data["content"]["token"]);
            authService.login(requestData).then(
              (data) => {
                if (data.result == 0) {
                  self.isSubmitting = false;
                  common.setSession(
                    {
                      session: data.content.sess,
                      memberId: data.content.memberId,
                    },
                    7
                  );
                  self.signInSuccessHandler(data);
                } else {
                  self.isSubmitting = false;
                  if (data) {
                    self.signInFailHandler(data);
                  }
                  // window.$sk.tips.show(data["desc"]);
                }
              },
              (data) => {
                window.$sk.tips.show(data["desc"]);
                self.isSubmitting = false;
              }
            );
          },
          (data) => {
            window.$sk.tips.show(data["desc"]);
            self.isSubmitting = false;
            return false;
          }
        );
    },
    wapJumpQQUrl() {
      // this.returnUrl = URLS.updateSearchParam("backUrl", window.btoa(this.backUrl), this.returnUrl);
      window.$sk.goto(this.qq.loginUrl + "?return_url=" + this.returnUrl);
    },
    wapJumpweChatUrl() {
      if (this.inWeChat) {
        window.$sk.goto(this.weChat.loginUrl + "?return_url=" + this.returnUrl);
      } else {
        window.$sk.goto(
          "https://cdn.smarket.net.cn/components/wap.html?backurl=" +
            encodeURIComponent(window.location.href) +
            (window.location.hash.indexOf("?") > -1 ? "&" : "?") +
            "return_url=" +
            this.returnUrl
        );
      }
    },
    qqlogin() {
      this.pcReturnUrl = URLS.updateParam(
        "backUrl",
        encodeURIComponent(window.btoa(this.backUrl)),
        this.pcReturnUrl
      );
      this.pcReturnUrl = URLS.updateParam(
        "sourceKey",
        common.sourceKey,
        this.pcReturnUrl
      );
      this.pcReturnUrl = this.pcReturnUrl.replace(
        /#[\s\S]+$/,
        `#/${common.platform}_login`
      );
      window.$sk.goto(
        this.qq.loginUrl + "?return_url=" + encodeURIComponent(this.pcReturnUrl)
      );
    },
    wechatLogin() {
      this.pcReturnUrl = URLS.updateParam(
        "backUrl",
        encodeURIComponent(this.backUrl),
        this.pcReturnUrl
      );
      this.pcReturnUrl = URLS.updateParam(
        "sourceKey",
        common.sourceKey,
        this.pcReturnUrl
      );
      this.pcReturnUrl = this.pcReturnUrl.replace(
        /#[\s\S]+$/,
        `#/${common.platform}_login`
      );
      window.$sk.goto(
        this.weChatWeb.loginUrl +
          "?return_url=" +
          encodeURIComponent(this.pcReturnUrl)
      );
    },
    openOtherModel() {
      this.isShowOtherModel ? this.hide() : this.show();
    },
    show() {
      this.isShowOtherModel = true;
      document.addEventListener("click", this.hidePanel, false);
    },
    hide() {
      this.isShowOtherModel = false;
      document.removeEventListener("click", this.hidePanel, false);
    },
    hidePanel(el) {
      try {
        if (!this.$refs.otherModel.contains(el.target)) {
          this.hide();
        }
      } catch (e) {
        console.log(e);
      }
    },
    loginTypeChange(item) {
      if (item.isSystemed + "" == "1") {
        this.isNormal = true;
        this.loginType = this.normalIdentityFields
          .map((item) => {
            return item["fieldName"];
          })
          .join("/");
        this.customField = null;
      } else {
        this.loginType = item.fieldName;
        this.customPlaceholder = item.displayName;
        this.isNormal = false;
        this.customField = item;
      }
      this.accountErrorMsg = "";
      this.passwordSignInErrorMsg = "";
      this.isPassWordLogin = true;
      // this.$forceUpdate();
      this.isShowOtherModel = false;
    },
    signInSuccessHandler(data) {
      this.isSubmitting = false;
      // let nextUrl = URLS.getHash("backUrl") || this.backUrl || "loginSuccess";
      switch (data["content"]["status"]) {
        case "required":
          common.routerPush(this, "bindRegister", {
            backUrl: common.backUrl,
            token: this.token,
          });
          break;
        case "increase":
          common.routerPush(this, "increase", {
            backUrl: common.backUrl,
          });
          break;
        case "normal":
          if (common.backUrl || this.settingBackUrl) {
            if (this.backUrl) {
              common.handBackUrl(common.backUrl);
            } else {
              window.$sk.goto(this.settingBackUrl);
            }
          } else {
            common.routerPush(this, "loginSuccess", { token: this.token });
          }

          break;
        case "auditing":
          return window.$sk.tips.show("您的账号信息正在审核中，请耐心等待");
        case "disabled":
          return window.$sk.tips.show("您的账号暂无权限登录");
      }
    },
    signInFailHandler(data) {
      this.isSubmitting = false;
      if (data["result"] === -100) {
        common.routerReplace(this, "phoneRegister", {
          phone: this.phoneFieldValue,
          code: this.phoneField.isCallingCodeOpen == 1 ? this.phone : "",
          country: this.phoneField.isCallingCodeOpen == 1 ? this.country : "",
          backUrl: common.backUrl,
        });
        return;
      } else if (data["result"] === -101) {
        //使用verify登录失败，继续后续流程，登录成功时将注册用户与verify绑定
        return;
      }
      window.$sk.tips.show(data["desc"]);
      // vm.showToast(data["desc"]);
    },
    skUserInit() {},
    skUserEnd() {
      let json = window.$sk.template.get();
      common.register(json);
      this.initConfig(this.loginInit);
      // this.loginInit();
    },
    skUserChange() {
      let json = window.$sk.template.get();
      console.log(json);
    },
    skLinkEnd() {
      let self = this;
      self.load();
      //如果已完成第三方授权拿到token则尝试登录
      self.verify = common.getVerify(self.weChatId);
      if (self.token || self.verify) {
        common.setToken(self.token);
        // alert(window.location.href);
        authService
          .login({
            tenantId: common.tenantId, //int 租户Id
            schemaId: self.schemaId, //int 体系Id（选填）
            globalUserId: common.globalUserId,
            memberFormId: self.memberFormId,
            memberSchemaId: self.memberSchemaId, //表单id
            unique: "", //string 唯一标识。可能是用户名，邮箱，手机等;记录住密码的传 cookie
            token: self.token, //string 第三方登录传 token，token时不需要密码或是动态验证码 ;
            verify: self.verify,
            password: "", //string 密码。账号密码的形式必传此项。
            checkCode: "", //string 动态验证码。手机或邮箱动态验证登录传此项
            loginType: "", //string 登录方式（选填。主要是用于标识用户名，邮箱，手机等.其他标识方式必填）
            url: window.location.href,
            browseInfo: interact.browseInfo,
            weChatId: self.weChatId ? self.weChatId : "",
          })
          .then(
            (data) => {
              let tokenInfo = data["content"]["tokenInfo"];
              common.setTokenInfo(tokenInfo);
              self.openId = tokenInfo["providerId"];
              self.name = tokenInfo["name"];
              self.nickname = tokenInfo["nickname"];
              self.avatar = tokenInfo["avatar"];
              self.email = tokenInfo["email"];
              if (data["content"]["sess"]) {
                common.setSession(
                  {
                    session: data.content.sess,
                    memberId: data.content.memberId,
                  },
                  7
                );
              }
              self.signInSuccessHandler(data);
            },
            (data) => {
              // $("#content").show();
              self.signInFailHandler(data);
            }
          );
      }
    },
  },
  created() {
    window.$sk.loading.show();
    if (this.isSetting) {
      this.initConfig();
      this.protoInit(loginData);
      this.isEnableSignup = true;
      this.isLoad = true;
      window.$sk.loading.hide();
      return;
    }
    this.sk = window.$sk.template.module(this);
    window.localStorage["redirect_wx"] = window.location.href;
  },
  mounted() {},
  beforeDestroy() {
    this.sk.unsubscribe();
  },
};
